import React from 'react';
import {
    Area,
    AreaChart,
    Bar,
    BarChart,
    Cell,
    Line,
    LineChart,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis
} from 'recharts';

import InfoCard from 'components/InfoCard';
import CardBox from 'components/CardBox';
import WeatherDetail from 'components/Weather/WeatherDetail';
import MonthlyReportLineChart from './Components/MonthlyReportLineChart';
import BestSellingMonthBarChart from './Components/BestSellingMonthBarChart';

import SupplyProducts from 'components/toliton/dashboard/supplyProducts/supplyProducts';

import {get} from 'engine/dataServices';

import Coins from 'assets/Images/SwiftImageIcons/Colored/1x/Coins.png';
import CoinStack from 'assets/Images/SwiftImageIcons/Colored/1x/Coinstack.png';
import Coinincrease from 'assets/Images/SwiftImageIcons/Colored/1x/Coinincrease.png';
import DollarStats from 'assets/Images/SwiftImageIcons/Colored/1x/Dollarstats.png';
import DollarBagC from 'assets/Images/SwiftImageIcons/Colored/1x/Dollarbag.png';
import Loading from 'app/loading';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#c23616'];

class Default extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            waitProductCount: 0,
            last7SaleDayCount: 0,
            last30SaleDayCount: 0,
            totalSaleCount: 0,
            totalSalePrice: 0,
            saleChart: [],
            mostLike: [],
            mostComment: [],
            topProducts: [],
            cardsData: '',
            last7DayCountData: '',
            last30DayCountData: '',
            totalCountData: ''
        }

    }

    componentWillMount() {
        this.loadData();
    }

    componentDidMount() {

    }

    async loadData() {
        this.handleLoading(true);

        const res = await get('Order/GetDashboard')
        if (res.status == 200) {

            const data = await res.json();

            debugger;

            this.setState({
                waitProductCount: data.WaitProductCount,
                last7SaleDayCount: data.Last7DaySaleCount,
                last30SaleDayCount: data.Last30DaySaleCount,
                totalSaleCount: data.TotalSale,
                totalSalePrice: data.TotalIncome,
                saleChart: data.SaleReport,
                mostLike: data.LikeCount,
                mostComment: data.CommentCount,
                topProducts: data.OrderCount
            });


            /*
                        this.handleIncresingNumbers('waitProductCount', data.WaitProductCount, 1);
                        this.handleIncresingNumbers('last7SaleDayCount', data.Last7DaySaleCount, 1);
                        this.handleIncresingNumbers('last30SaleDayCount', data.Last30DaySaleCount, 1)
                        this.handleIncresingNumbers('totalSaleCount', data.TotalSale, 1)
                        this.handleIncresingNumbers('totalSalePrice', data.TotalIncome, 10100)
            */


        }

        this.handleLoading(false)
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleIncresingNumbers = (key, value, additive) => {
        let current = 0;
        const timeOut = 50;

        const interval = setInterval(() => {
            this.setState({[key]: current});
            current = current + additive;
            if (current > value)
                clearInterval(interval);
        }, timeOut);
    };

    render() {
        const {mostLike, mostComment, topProducts} = this.state;

        let waitProductCountCard = {
            img: Coins,
            title: 'در انتظار محصول',
            subTitle: (this.state.waitProductCount) ? this.state.waitProductCount : '...',
        };
        const last7SaleDayCountCard = {
            img: CoinStack,
            title: 'فروش 7 روزه',
            subTitle: (this.state.last7SaleDayCount) ? this.state.last7SaleDayCount : '...',
        };
        const last30SaleDayCountCard = {
            img: Coinincrease,
            title: 'فروش 30 روزه',
            subTitle: (this.state.last30SaleDayCount) ? this.state.last30SaleDayCount : '...',
        };
        const totalSaleCountCard = {
            img: DollarBagC,
            title: 'کل فروش ها',
            subTitle: (this.state.totalSaleCount) ? this.state.totalSaleCount : '...',
        };
        const totalSalePriceCard = {
            img: DollarStats,
            title: 'کل درآمد کسب شده',
            subTitle: ((this.state.totalSalePrice) ? this.state.totalSalePrice.toLocaleString() : '...') + ' تومان',
        };

        const mostLikePieChart = [];

        if (mostLike) {
            for (let i = 0; i < mostLike.length; i++) {
                let item = mostLike[i];
                mostLikePieChart.push({name: item.ProductName, amt: item.Count});
            }
        }

        const mostCommentPieChart = [];

        if (mostComment) {
            for (let i = 0; i < mostComment.length; i++) {
                let item = mostComment[i];
                mostCommentPieChart.push({name: item.ProductName, amt: item.CommentCount});
            }
        }

        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">

                {this.state.loading && <Loading/>}

                <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={waitProductCountCard} styleName="bg-cyan darken-12 text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={last7SaleDayCountCard} styleName="bg-secondary darken- text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={last30SaleDayCountCard} styleName="bg-primary text-right"/>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-3 col-sm-6 col-12">
                        <InfoCard data={totalSaleCountCard} styleName="bg-red darken-1 text-right"/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className="row">
                            <div className="col-lg-12">
                                <CardBox heading="نمودار فروش">
                                    <MonthlyReportLineChart data={this.state.saleChart}/>
                                </CardBox>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="jr-card">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <h3 className="card-heading">
                                                محصولات محبوب (بیشترین لایک)
                                            </h3>
                                            <ResponsiveContainer className="mb-4 mb-sm-1 unset-position" height={130}>
                                                <PieChart>
                                                    <Pie dataKey="amt"
                                                         data={mostLikePieChart} cx="50%" cy="50%"
                                                         innerRadius={40}
                                                         outerRadius={60}
                                                         fill="#3367d6"
                                                         paddingAngle={5}
                                                    >
                                                        {
                                                            mostLikePieChart.map((entry, index) =>
                                                                <Cell key={index}
                                                                      fill={COLORS[index % COLORS.length]}/>)
                                                        }
                                                    </Pie>
                                                    <Tooltip/>
                                                </PieChart>
                                            </ResponsiveContainer>
                                            <div style={{textAlign: 'center'}}>
                                                {
                                                    mostLikePieChart.map((item, index) => {
                                                            const style = {
                                                                width: 15,
                                                                height: 15,
                                                                borderRadius: 20,
                                                                backgroundColor: COLORS[index % COLORS.length],
                                                                float: 'right'
                                                            }

                                                            return (
                                                                <div style={{width: '50%', float: 'right'}}>
                                                                    <div style={style}></div>
                                                                    <div>
                                                                        <span>{item.name}</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="jr-card">
                                    <div className="row">
                                        <div className="col-sm-12 col-12">
                                            <h3 className="card-heading">
                                                محصولات چالشی (بیشترین نظرات)
                                            </h3>
                                            <ResponsiveContainer className="mb-4 mb-sm-1 unset-position" height={130}>
                                                <PieChart>
                                                    <Pie dataKey="amt"
                                                         data={mostCommentPieChart} cx="50%" cy="50%"
                                                         innerRadius={40}
                                                         outerRadius={60}
                                                         fill="#3367d6"
                                                         paddingAngle={5}
                                                    >
                                                        {
                                                            mostCommentPieChart.map((entry, index) => <Cell key={index}
                                                                                                            fill={COLORS[index % COLORS.length]}/>)
                                                        }
                                                    </Pie>
                                                    <Tooltip/>
                                                </PieChart>
                                            </ResponsiveContainer>
                                            <div style={{textAlign: 'center'}}>
                                                {
                                                    mostCommentPieChart.map((item, index) => {
                                                            const style = {
                                                                width: 15,
                                                                height: 15,
                                                                borderRadius: 20,
                                                                backgroundColor: COLORS[index % COLORS.length],
                                                                float: 'right'
                                                            }

                                                            return (
                                                                <div style={{width: '50%', float: 'right'}}>
                                                                    <div style={style}></div>
                                                                    <div>
                                                                        <span>{item.name}</span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 col-12">
                        <div>
                            <InfoCard data={totalSalePriceCard} styleName="text-right bg-teal accent-4 text-white"/>
                        </div>
                        <div className="jr-card">
                            <WeatherDetail/>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <SupplyProducts/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <CardBox heading="5 محصول پر فروش">
                            <BestSellingMonthBarChart data={topProducts}/>
                        </CardBox>
                    </div>
                </div>


            </div>

        );
    }
}

export default Default;



// WEBPACK FOOTER //
// ./app/routes/toliton/dashboard/dashboard.js